import React from 'react';
import { useCRM } from '../context/CRMContext';
import { useNavigate } from 'react-router-dom';
import SafeIcon from './SafeIcon';

/**
 * A wrapper to protect routes or components based on permissions.
 * @param {string} permission - The permission key to check (e.g., 'canImportBrreg')
 * @param {boolean} redirect - If true, redirects to dashboard instead of showing error
 */
const PermissionGate = ({ children, permission, redirect = false }) => {
  const { permissions } = useCRM();
  const navigate = useNavigate();

  if (permissions[permission]) {
    return children;
  }

  if (redirect) {
    // We can't easily redirect during render, so return null and useEffect would be better 
    // but for simplicity in this artifact structure, we'll show the error state which offers a button.
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center p-8">
      <div className="w-24 h-24 bg-slate-100 rounded-full flex items-center justify-center mb-6">
        <SafeIcon icon="🔒" className="w-10 h-10 text-slate-400" />
      </div>
      <h2 className="text-2xl font-black text-slate-900 mb-2">Ingen tilgang</h2>
      <p className="text-slate-500 max-w-md mx-auto mb-8 font-medium">
        Du har ikke tilstrekkelige rettigheter til å se denne siden. Kontakt din administrator eller partneransvarlig.
      </p>
      <button 
        onClick={() => navigate('/dashboard')}
        className="px-8 py-3 bg-slate-900 text-white rounded-xl font-bold hover:bg-slate-800 transition-all"
      >
        Gå til Dashboard
      </button>
    </div>
  );
};

export default PermissionGate;